import { Container } from "react-bootstrap";

export default function Text() {
  return (
    <Container>
      <p
        style={{
          textAlign: "justify",
          fontSize: "1em",
          paddingLeft: "1em",
          paddingRight: "1em",
          fontFamily:"'Inria Serif', serif",
          padding:"0 10%",
        }}
      >
        Building Engineering Architecture Management Services (BEAMS) is a
        cutting-edge, web-based platform dedicated to revolutionizing
        engineering and construction management for building and infrastructure
        projects. BEAMS seamlessly integrates expertise from concept creation to
        design, development, and execution, ensuring precision, efficiency, and
        excellence at every stage. Designed to empower professionals, BEAMS is
        an initiative that embraces global methodologies, technologies, and
        trends, adapting them to the unique needs of the Indian construction
        industry. It provides young architects and engineers with the tools,
        knowledge, and confidence to tackle complex managerial roles, driving
        innovation and excellence within the sector. At its core, BEAMS is
        committed to equipping industry leaders with reliable, accurate insights
        to ensure projects are delivered on time, within budget, and with
        uncompromising quality. With a sharp focus on design management,
        construction planning, and operational excellence, BEAMS offers a
        comprehensive approach to project management. Through advanced
        techniques like network analysis, operational research, financial and
        cost management, contract negotiation, resource optimization, and
        quality assurance, BEAMS addresses every facet of construction and
        building engineering. Additionally, it incorporates specialized services
        in structural systems, building science, and cutting-edge computer
        applications, making it a one-stop solution for modern construction
        management needs. BEAMS isn’t just a service; it’s a commitment to
        shaping the future of the construction industry with innovation,
        integrity, and unmatched expertise.
      </p>
    </Container>
  );
}
